const state = {
  fkList: [],
  zkCardNo: '',
  fkInfo: {},
  isElec: 0 // 0:实体卡 1:电子卡
}

const mutations = {
  SET_FK_LIST(state, list) {
    state.fkList = list
  },
  SET_ZK_CARDNO(state, cardNo) {
    state.zkCardNo = cardNo
  },
  SET_FK_INFO(state, info) {
    state.fkInfo = info
  },
  SET_IS_ELEC(state, isElec) {
    state.isElec = isElec
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
